import { render, staticRenderFns } from "./EditCollect.vue?vue&type=template&id=fc695e32&"
import script from "./EditCollect.vue?vue&type=script&lang=js&"
export * from "./EditCollect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports